import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function SignedOut() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-12">
      <div className="w-full max-w-[400px] space-y-8 text-center">
        {/* Logo */}
        <div className="flex justify-center">
          <span className="text-xl font-bold text-primary tracking-tight">
            mySuccession
          </span>
        </div>

        {/* Icon */}
        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-primary/10">
          <Shield className="h-7 w-7 text-primary" />
        </div>

        {/* Heading */}
        <h1 className="text-2xl font-bold text-foreground">
          You've been signed out
        </h1>

        {/* Body */}
        <p className="text-sm text-muted-foreground leading-relaxed">
          For your security, we signed you out after a period of inactivity. Your progress has been saved — simply sign back in to continue.
        </p>

        {/* CTA */}
        <Button
          onClick={() => navigate('/login', { replace: true })}
          className="w-full bg-primary hover:bg-primary/90 text-primary-foreground"
          size="lg"
        >
          Sign Back In
        </Button>
      </div>
    </div>
  );
}
